import React from 'react'


function OpenAccount() {
    return ( 
        <div className='container p-5'>
            <div className='row text-center '> <a href="signup">
                <h3 className='mt-3'>This Page Not Found</h3> <br></br><br></br><br></br>
                <p style={{color: "gray"}}>Try something logical</p><br></br><br></br>
                </a>
            </div>
        </div>
     );
}
 
export default OpenAccount;